export default "__VITE_ASSET__Nfj7UnqD__"